var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCondensed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340 340",
    enableBackground: "new 0 0 340 340",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M170.4,1.6C77.8,1.6,2.6,76.8,2.6,169.4s75.1,167.8,167.8,167.8s167.8-75.1,167.8-167.8 S263.1,1.6,170.4,1.6z M282.7,147.7l-5.4,23.7c-0.4,1.6-1.9,2.6-3.6,2.3c-7.2-1.4-17.8-3-30.7-4c0.6,29.4,1.8,53.7,2.6,62.8 c0.2,1.6-1,3-2.6,3.3l-24,3.8c-1.7,0.3-3.3-1-3.5-2.7c-1.2-11.4-2.4-39.2-3-68.1c-14.2,0.2-29.4,1.2-44.7,3.8 c-0.3,28.1-5,50-14,65.4c-11.3,19.2-28.3,29.9-46.6,29.9c-3,0-6.1-0.3-9.2-0.9c-20.5-4-37-21-40.1-41.5 c-1.7-11.3-1.3-40.1,39.2-61.7c12-6.4,25.2-11.6,39.5-15.6c-1.6-22-5.4-45.3-10.1-66.6c-0.4-1.6,0.7-3.2,2.3-3.6l23.7-5.3 c1.6-0.4,3.3,0.7,3.6,2.3c3.2,14.6,8.1,39.9,10.4,66.9c14.1-2.1,29-3.3,44.7-3.5c0.3,0,0.7,0,1,0c0.1-31,1.7-48.6,3.6-64 c0.2-1.7,1.8-2.9,3.5-2.6l23.6,4.1c1.6,0.3,2.7,1.8,2.5,3.4c-1.3,10.3-2.8,27.7-2.9,60.2c16.5,1.2,29.8,3.2,37.6,4.7 C282,144.4,283,146,282.7,147.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M88,220.9c1.2,7.8,7.8,14.6,15.9,16.2c8.8,1.7,17.3-3.5,23.9-14.6c6-10.2,8.9-25.2,9.7-42.7 c-9,2.9-17.7,6.5-25.9,10.8C95,199.3,86.5,210.4,88,220.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCondensed);
export default __webpack_public_path__ + "static/media/logo-condensed.7215587ef06964885b00337e49d12fee.svg";
export { ForwardRef as ReactComponent };